import "@app/App.css";
import { Notification } from "@comps/ui/notification";
import { Popover, PopoverContent, PopoverTrigger } from "@comps/ui/popover";
import { FullRightAccess, ViewRightType, hasGlobalRightAccess } from "@dto/Users";
import { Sorting } from "@dto/views";
import { getFieldByPathKeys } from "@utils/model";
import { TW_ObjectHeaderButtonTitle, TW_ObjectModelViewHeaderButton, TW_ObjectModelViewHeaderIcon } from "@utils/twClasses";
import { ArrangeVertical } from "iconsax-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataStore, useModelStore, useUserStore } from "src/store";
import SortingEditor from "./SortingEditor";

function SortButton() {

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const selectedView = useModelStore((state) => state.selectedView);
  const selectedObjectInfos = useModelStore((state) => state.selectedObjectInfos);
  const { t } = useTranslation();
  const user = useUserStore((state) => state.user);
  const userRole = useModelStore((state) => state.userRole);
  const rowActionsEnabled = useDataStore(state => state.rowActionsEnabled);

  const fields = selectedObjectInfos?.fields || null;
  const fieldByKeys = useModelStore(state => state.fieldByKeys);
  const relationByKeys = useModelStore(state => state.relationByKeys);
  const fieldByPathKeys = getFieldByPathKeys(selectedObjectInfos, selectedObjectInfos?.fields || [], relationByKeys, fieldByKeys);

  const sortedFields = selectedView?.sortings?.filter((sorting: Sorting) => fieldByPathKeys.get(sorting.pathKey));
  const numberOfSortedFields = sortedFields?.length || 0;

  const hasFullAccess = selectedView?.ownerKey === user?._key || hasGlobalRightAccess(user, userRole, ViewRightType, FullRightAccess, selectedView?._key);
  const isDisabled = (!fields || fields.length === 0) || !rowActionsEnabled;
  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger disabled={isDisabled} className={TW_ObjectModelViewHeaderButton + (isDisabled ? " opacity-50 cursor-not-allowed" : " opacity-100 cursor-default")}>
        <div className="flex flex-row justify-start items-center relative">
          <ArrangeVertical className={TW_ObjectModelViewHeaderIcon} />
          {numberOfSortedFields > 0 && <Notification number={numberOfSortedFields} />}
        </div>
        <span className={TW_ObjectHeaderButtonTitle}>{t('object.header.button.sort.rows.title')}</span>
      </PopoverTrigger>
      <PopoverContent className="w-max p-2">
        <SortingEditor sortings={sortedFields || []} disabled={!hasFullAccess} onClose={() => setIsPopoverOpen(false)} />
      </PopoverContent>
    </Popover>
  )
}

export default SortButton;